import {
  Fonts,
} from "assets/jss/Main";

const HeaderStyle = {  
  root: {
    color: "white",
    backgroundColor: "#474c55 !important",
    //backgroundColor: "#474c55 !important",
    // old 474c55
    borderLeftColor: "#474c55 !important",
    borderRightColor: "#474c55 !important",
    borderTopColor: "#474c55 !important",
    borderBottomColor: "#474c55 !important",
    textAlign: "center",
    "& h3:last-child": {
      fontWeight: "bold"
    },
    cursor: "pointer",
  },
  aardvarkFace: {
    backgroundColor: "#474c55 !important",
    //backgroundColor: "#474c55 !important",
    borderLeftColor: "#474c55 !important",
    borderRightColor: "#474c55 !important",
    borderTopColor: "#474c55 !important",
    borderBottomColor: "#474c55 !important",
    opacity: "1 !important"
    //color: "red"
  },
  headerRoot: {
    marginRight: "5px",
    backgroundColor: "#70737b",
    //backgroundColor: "rgb(94, 94, 94, 0.6)",
    lineHeight: "30px",
    borderRadius: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    //...Fonts.medium
  },
  profileButton: {
    position: "absolute",
    right: "0px"
  }
}

export default HeaderStyle
